/* Salt + Ember — Bundle Builder (scaffold v1)
   Client-side set building + tiered-savings display + add-to-cart.
   The tiered discount IS wired: the salt-ember-bundles Shopify Function plus
   the "Bundle Set Tiers" automatic discount enforce it at checkout. Verified
   firing at 2, 4 and 8 items. Do not bolt a second discount mechanism on. */
(function () {
  const root = document.querySelector('[data-bundle-builder]');
  if (!root) return;

  const money = (cents) =>
    '$' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const T2 = parseInt(root.dataset.tier2, 10) || 0;
  const T4 = parseInt(root.dataset.tier4, 10) || 0;
  const T8 = parseInt(root.dataset.tier8, 10) || 0;

  const tray = root.querySelector('[data-tray]');
  const itemsEl = root.querySelector('[data-tray-items]');
  const countEl = root.querySelector('[data-count]');
  const subtotalEl = root.querySelector('[data-subtotal]');
  const savingsEl = root.querySelector('[data-savings]');
  const progressEl = root.querySelector('[data-progress]');
  const addSetBtn = root.querySelector('[data-add-set]');
  const giftEl = root.querySelector('[data-gift]');
  const trackFillEl = root.querySelector('[data-track-fill]');
  const milestoneEls = root.querySelectorAll('[data-milestone]');
  const statusEl = root.querySelector('[data-bb-status]');
  let prevTier = 0;

  // Captured from the markup so the restored label matches the theme setting.
  const ADD_LABEL = addSetBtn ? addSetBtn.textContent.trim() : 'Add Set to Cart';
  const setStatus = (msg) => {
    if (statusEl) statusEl.textContent = msg;
  };

  // selected: { variantId: {title, price(cents), qty} }
  const selected = new Map();

  function tierFor(count) {
    if (count >= 8) return T8;
    if (count >= 4) return T4;
    if (count >= 2) return T2;
    return 0;
  }

  function progressMessage(count) {
    if (count === 0) return 'Add candles to start building your set.';
    if (count === 1) return `Add 1 more to save ${T2}%.`;
    if (count < 4) return `You're saving ${T2}%. Add ${4 - count} more for ${T4}% off.`;
    if (count === 4) return `Nice — ${T4}% off. Add 4 more to unlock ${T8}% off everything.`;
    if (count < 8) return `${8 - count} more to reach ${T8}% off your whole set.`;
    return `Full set! You're saving ${T8}% on all ${count}.`;
  }

  function totalCount() {
    let c = 0;
    selected.forEach((v) => (c += v.qty));
    return c;
  }

  function render() {
    const count = totalCount();
    let subtotal = 0;
    selected.forEach((v) => (subtotal += v.price * v.qty));
    const tier = tierFor(count);
    const savings = Math.round(subtotal * (tier / 100));

    tray.hidden = count === 0;
    countEl.textContent = count;
    subtotalEl.textContent = money(subtotal);

    if (savings > 0) {
      savingsEl.hidden = false;
      savingsEl.textContent = `You save ${money(savings)} (${tier}%)`;
    } else {
      savingsEl.hidden = true;
    }

    progressEl.textContent = progressMessage(count);
    addSetBtn.disabled = count === 0;

    // progress bar: piecewise fill between evenly spaced milestones (2 @ 33%,
    // 4 @ 66%, 8 @ 100%) so every add produces visible motion
    if (trackFillEl) {
      let pct;
      if (count <= 0) pct = 0;
      else if (count <= 2) pct = (count / 2) * 33.33;
      else if (count <= 4) pct = 33.33 + ((count - 2) / 2) * 33.33;
      else pct = 66.66 + Math.min(1, (count - 4) / 4) * 33.34;
      trackFillEl.style.width = pct + '%';
    }
    milestoneEls.forEach((m) => {
      m.classList.toggle('reached', count >= parseInt(m.dataset.milestone, 10));
    });

    // celebrate crossing into a new tier
    if (tier > prevTier && tier > 0) {
      tray.classList.remove('bb-celebrate');
      void tray.offsetWidth; // restart animation
      tray.classList.add('bb-celebrate');
    }
    prevTier = tier;

    itemsEl.innerHTML = '';
    selected.forEach((v, id) => {
      const chip = document.createElement('span');
      chip.className = 'bb-chip';
      chip.innerHTML =
        `${v.title}${v.qty > 1 ? ' ×' + v.qty : ''} ` +
        `<button type="button" class="bb-chip-remove" aria-label="Remove ${v.title}" data-remove="${id}">×</button>`;
      itemsEl.appendChild(chip);
    });
  }

  // add a scent
  root.querySelectorAll('.bb-card').forEach((card) => {
    const btn = card.querySelector('[data-add]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const id = card.dataset.variantId;
      if (!id) return;
      const existing = selected.get(id);
      if (existing) existing.qty += 1;
      else selected.set(id, { title: card.dataset.title, price: parseInt(card.dataset.price, 10) || 0, qty: 1 });
      render();
    });
  });

  // remove from tray
  itemsEl.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove]');
    if (!rm) return;
    const id = rm.dataset.remove;
    const v = selected.get(id);
    if (!v) return;
    if (v.qty > 1) v.qty -= 1;
    else selected.delete(id);
    render();
  });

  // add the set to cart
  addSetBtn.addEventListener('click', async () => {
    if (totalCount() === 0) return;
    addSetBtn.disabled = true;
    addSetBtn.textContent = 'Adding…';
    const items = [];
    selected.forEach((v, id) => items.push({ id: Number(id), quantity: v.qty }));
    // 'Gift', not '_gift'. Shopify treats a leading underscore as a hidden
    // property and both cart views filter those out (cart-drawer.liquid:187,
    // main-cart-items.liquid:144), so the shopper got no confirmation the gift
    // option had taken. Matches discovery-set.js, which already did this.
    const properties = giftEl && giftEl.checked ? { Gift: 'Yes' } : undefined;
    // Open the cart drawer rather than redirecting to /cart. The drawer carries
    // the free shipping bar and the accessories upsell; /cart carries neither.
    const cartDrawer = document.querySelector('cart-drawer');
    const body = { items: items.map((i) => (properties ? { ...i, properties } : i)) };
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      });
      const parsed = await res.json();
      // /cart/add.js is atomic: one sold-out variant fails the whole set. A 4xx
      // resolves rather than throws, so without this check the shopper was sent
      // to an empty cart with no explanation.
      if (!res.ok || parsed.status) {
        throw new Error(parsed.description || parsed.message || 'cart/add failed: ' + res.status);
      }

      setStatus('');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsed);
        addSetBtn.disabled = false;
        addSetBtn.textContent = ADD_LABEL;
      } else {
        window.location.href = '/cart'; // no drawer on this theme setting
      }
    } catch (err) {
      addSetBtn.disabled = false;
      addSetBtn.textContent = ADD_LABEL;
      setStatus("Sorry, we couldn't add that set. One of those candles may have just sold out. Try removing it, or email us and we'll sort it.");
      console.error('[bundle-builder] add to cart failed', err);
    }
  });

  render();
})();
